import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  postMessage: null,
  postError: null,
  data: undefined,
};
const postPetFormTwoSlice = createSlice({
  name: "postPetFormTwo",
  initialState,
  reducers: {
    postPetFormTwoStart(state, payload) {
      state.loading = true;
      state.postError = null;
      state.postMessage = null;
    },

    postPetFormTwoSuccess(state, action) {
      state.loading = false;
      state.data = action.payload;
    },
    postPetFormTwoDataSuccess(state, action) {
      state.loading = false;
      state.data = action.payload;
    },

    postPetFormTwoFailure(state, action) {
      state.loading = false;
      state.postError = action.payload;
      state.postMessage = null;
    },

    clearMessage: (state) => {
      state.postError = null;
      state.postMessage = null;
    },
  },
});

export const {
  postPetFormTwoStart,
  postPetFormTwoSuccess,
  postPetFormTwoFailure,
  postPetFormTwoDataSuccess,
  clearError,
  clearMessage,
} = postPetFormTwoSlice.actions;

export default postPetFormTwoSlice.reducer;
